import React, { forwardRef, useState, useEffect } from "react";
import { __ } from "@wordpress/i18n";
import { CustomNumberControl } from "../CustomNumberInput";
import { Button, Notice, Spinner } from "@wordpress/components";
import { getImageHubSettings } from "../../context/useSettings";

const ajaxUrl = image_hub_data.ajaxurl;
const nonce = image_hub_data.nonce;

const UnforwardedSizes = (props, ref) => {
	const [settings, setSettings] = useState({
		image_hub_max_image_width: 0,
		image_hub_max_image_height: 0,
	});
	const [originalSettings, setOriginalSettings] = useState({
		image_hub_max_image_width: 0,
		image_hub_max_image_height: 0,
	});

	const hasSettingsChanged = () => {
		return settings.image_hub_max_image_width !== originalSettings.image_hub_max_image_width ||
			settings.image_hub_max_image_height !== originalSettings.image_hub_max_image_height;
	};

	const [isSaving, setIsSaving] = useState(false);
	const [saveMessage, setSaveMessage] = useState("");
	const [saveStatus, setSaveStatus] = useState("");

	const { imageHubSettings, isLoading } = getImageHubSettings();

	useEffect(() => {
		setSettings({
			image_hub_max_image_width:
				imageHubSettings.image_hub_max_image_width || 0,
			image_hub_max_image_height:
				imageHubSettings.image_hub_max_image_height || 0,
		});
		setOriginalSettings({
			image_hub_max_image_width:
				imageHubSettings.image_hub_max_image_width || 0,
			image_hub_max_image_height:
				imageHubSettings.image_hub_max_image_height || 0,
		})
	}, [imageHubSettings]);

	const handleSettingChange = (key, value) => {
		setSettings((prev) => ({
			...prev,
			[key]: +value,
		}));
	};

	const saveSettings = () => {
		setIsSaving(true);

		fetch(ajaxUrl, {
			method: "POST",
			body: new URLSearchParams({
				action: "image_hub_update_settings",
				nonce: nonce,
				data:JSON.stringify( settings )
			}),
		}).then(() => {
				setIsSaving(false);
				setSaveMessage(__("Settings saved successfully!", "image-hub"));
				setSaveStatus("success");
				setOriginalSettings(settings)
				setTimeout(() => {
					setSaveMessage("");
					setSaveStatus("");
				}, 3000);
			})
			.catch((error) => {
				console.error("Error saving settings:", error);
				setIsSaving(false);
				setSaveMessage(__("Failed to save settings.", "image-hub"));
				setSaveStatus("error");
			});
	};

	if (isLoading) {
		return (
			<div className="image-hub-settings-loading">
				<Spinner />
				<p>{__("Loading settings...", "image-hub")}</p>
			</div>
		);
	}

	return (
		<div ref={ref} className="image-hub-settings-sizes-container">
			<h1>{__("Max Upload Dimensions","image-hub")}</h1>
			<h4>
				{__(
					"Set a maximum width and height for downloaded images to control file size.",
				)}
			</h4>
			<div
				style={{
					width: "fit-content",
					gap: "1em",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<CustomNumberControl
					value={settings.image_hub_max_image_width}
					setValue={(value) =>
						handleSettingChange("image_hub_max_image_width", value)
					}
					label={__("Max. Width","image-hub")}
				/>
				<CustomNumberControl
					value={settings.image_hub_max_image_height}
					setValue={(value) =>
						handleSettingChange("image_hub_max_image_height", value)
					}
					label={__("Max. Height","image-hub")}
				/>
			</div>
			<br />
			<div style={{ display: "flex", gap: "10px", alignItems: "baseline", justifyContent: "space-between" }}>
				<Button
					style={{ marginTop: "16px" }}
					variant="primary"
					onClick={saveSettings}
					isBusy={isSaving}
					disabled={isSaving || !hasSettingsChanged()}
				>
					{isSaving
						? __("Saving...", "image-hub")
						: __("Save Settings", "image-hub")}
				</Button>
				<div style={{ width: "90%" }}>
					{saveMessage && (
						<Notice status={saveStatus} isDismissible={false}>
							{saveMessage}
						</Notice>
					)}
				</div>
			</div>
		</div>
	);
};

export const Sizes = forwardRef(UnforwardedSizes);
